import api from '../services/Api';
import { initialDataLoadedAction, shopDetectedAction } from '../actions/CompoundFetchActions';
import { networkErrorAction } from '../actions/UiActions';
import CompoundFetch from '../helpers/CompoundFetch';

class InitialDataRepository {

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	fetchInitialData = () => (dispatch) => api.post('/compound-fetch', {
		currencies: '/currencies/',
		mutations: '/mutations/',
		featureSwitches: '/feature-switches'
	}).then(res => {
		const data = res.data;
		let currencies = CompoundFetch.parseSubRequest(dispatch, data.currencies, 'currencies');
		let mutations = CompoundFetch.parseSubRequest(dispatch, data.mutations, 'mutations');
		const featureSwitches = CompoundFetch.parseSubRequest(dispatch, data.featureSwitches, 'featureSwitches');

		if (currencies && mutations && featureSwitches) {
			dispatch(initialDataLoadedAction(currencies, mutations, featureSwitches));
		}
		else {
			const msg = 'Compound fetch returned invalid data.';
			dispatch(networkErrorAction(msg));
		}
	});

	/**
	 * @return {function(*): Promise<AxiosResponse<any> | void>}
	 */
	fetchShopDetect = () => (dispatch) => api.get('/shop/detect')
		.then(res => {
			if (res.status > 400) {
				throw new Error('Bad response from server');
			}

			if (res.data && res.data.shopId) {
				dispatch(shopDetectedAction(res.data.shopId));
			}
		})
		.catch(error => console.log(error.message))
}

export default new InitialDataRepository();



// WEBPACK FOOTER //
// ./repositories/InitialDataRepository.js